module.exports = __webpack_public_path__ + "images/emoji/underage.c54e38e78ffac89131e2.png";